export const isInAppBrowser = (): boolean => {
  if (typeof navigator === "undefined") return false;

  const userAgent = navigator.userAgent.toLowerCase();

  const inAppPatterns = [
    /fban|fbav/,
    /instagram/,
    /twitter/,
    /snapchat/,
    /pinterest/,
    /line/,
    /wechat/,
    /tiktok/,
    /viber/,
    /telegram/,
    /whatsapp/,
  ];

  if (inAppPatterns.some((pattern) => pattern.test(userAgent))) {
    return true;
  }

  const isAndroidWebView =
    /wv/.test(userAgent) ||
    /version\/[\d.]+ chrome\/[\d.]+ mobile safari\/[\d.]+/.test(userAgent);
  if (isAndroidWebView) {
    return true;
  }

  const isIOS = /iphone|ipod|ipad/.test(userAgent);
  const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
  const isStandalone = (window.navigator as unknown as { standalone: boolean })
    .standalone;

  if (isIOS && !isSafari && !isStandalone) {
    return true;
  }

  return false;
};
